import {
	Row,
	Col,
	Card,
	Badge,
	Button,
	Image
} from 'react-bootstrap'
import JobTitle from './JobTitle'
import { useRouter } from 'next/router'
import moment from 'moment'
import styles from '../styles/Event.module.scss'
import { useTranslation } from 'next-i18next'

interface JobProps {
  job: any
  showAvatar: boolean
  withBorder?: boolean // making some props optional
  showCreatedDate?: boolean
  query: string
  showApplicationDate?: boolean
  isCompanyDetail?: boolean
}

const Job: React.FC<JobProps> = (props: JobProps) => {
	const { t } = useTranslation()
	const router = useRouter()
	const locale: string = router.locale as string

	const slugify = (str: string): string => {
		const a = 'àáâäæãåāăąçćčđďèéêëēėęěğǵḧîïíīįìłḿñńǹňôöòóœøōõőṕŕřßśšşșťțûüùúūǘůűųẃẍÿýžźż·/_,:;'
		const b = 'aaaaaaaaaacccddeeeeeeeegghiiiiiilmnnnnoooooooooprrsssssttuuuuuuuuuwxyyzzz------'
		const p = new RegExp(a.split('').join('|'), 'g')

		return str.toString().toLowerCase()
			.replace(/\s+/g, '-') // Replace spaces with -
			.replace(p, c => b.charAt(a.indexOf(c))) // Replace special characters
			.replace(/&/g, '-and-') // Replace & with 'and'
			.replace(/[^\w\-]+/g, '') // Remove all non-word characters
			.replace(/\-\-+/g, '-') // Replace multiple - with single -
			.replace(/^-+/, '') // Trim - from start of text
			.replace(/-+$/, '') // Trim - from end of text
	}

	const { job } = props

	const returnClassName = (): string => {
		if (props.withBorder === true) return styles.job
		else if (props.withBorder === false) return styles.jobTwo
		else return styles.jobThree // * applied page specific
	}

	const getJobTypeText = (jt: string): string => {
		return (jt === 'FT' ? 'Full Time' : (jt === 'PT' ? 'Part Time' : 'Contract'))
	}

	return (
		<a key={job.id} href={`/${locale}/job/${slugify(job.title)}-${job.id as string}${(typeof props.query !== 'undefined' && props.query !== '') ? '?' + props.query : ''}`} target='_blank' rel='noreferrer'>
			<Card className={returnClassName()} style={{ cursor: 'pointer' }}>
				<Card.Body style={{ padding: '1.25rem', boxShadow: props.isCompanyDetail ? 'none' : ''}}>
					<Row>
						{props.showAvatar &&
						<Col xs={3}>
							<div style={{ textAlign: 'center', width: '100%' }}>
								{job.Company.avatar !== null ? <Image thumbnail src={job.Company.avatar} style={{ maxWidth: '100%', objectFit: 'cover', border: '1px solid whitesmoke', alignItems: 'center', maxHeight: '150px' }} alt={job.title} /> : <div className={styles.companyAvatar}>{job.Company.name}</div>}
							</div>
						</Col>}
						<Col md={props.showAvatar ? 6 : 9} xs={props.showAvatar ? 9 : 12}>
							<JobTitle job={job} />
							<h3>{job.Company.name}</h3>
							<div style={{ marginTop: '5px', marginBottom: '10px' }}>
								{job.JobSalaries.map((js: any, i: number) => {
									return (js.min > 0 || js.max > 0) ? <span style={{ display: 'block' }} key={i}><small>{getJobTypeText(js.jobType)}</small> : <span style={{ fontWeight: 600 }}>{js.min > 0 ? `$ ${js.min as string}` : ''} {js.min > 0 && js.max > 0 ? ' - ' : ''} {js.max > 0 ? `$ ${js.max as string}` : ''}</span> <small> / {js.salaryType === null ? 'PER MONTH' : js.salaryType}</small></span> : ''
								})}
							</div>
							<div className={styles.badges}>
								{job.JobSalaries.map((js: any, i: number) => {
									return (
										<Badge key={i} pill bg='info' style={{ marginRight: '5px' }}>
											{js.jobType === 'FT' ? 'Full Time' : (js.jobType === 'PT' ? 'Part Time' : 'Contract')}
										</Badge>
									)
								})}
								{(typeof job.Category !== 'undefined' && job.Category !== null)
									? <><Badge pill bg='secondary'>{job.Category.name}</Badge> &nbsp;</>
									: (
										<>
											<Badge pill bg='secondary'>
												{job.Occupation !== null ? job.Occupation.name : ''}
											</Badge> &nbsp;
										</>
									)}
								{(typeof job.JobHashTags !== 'undefined' && job.JobHashTags !== null) &&
                  job.JobHashTags.length > 0 && job.JobHashTags.map((ele, index) => {
									const { Hashtag } = ele
									return (
										<Badge
											key={index}
											pill
											bg='secondary'
											style={{ backgroundColor: Hashtag.color, marginTop: '10px', marginRight: '5px' }}
										>
                      #{Hashtag.hashtag}
										</Badge>
									)
								})}
							</div>
						</Col>
						<Col md={3} className={styles.showDetailsContainer}>
							{/* {props.showCreatedDate && <span className='text-black-50'>{moment(job.jobPostStart).fromNow()}</span>} */}
							{props.showApplicationDate && <span className='text-black-50'>Applied {moment(job.JobApplicants[0].createdAt).fromNow()}</span>}
							<Button className='text-white' variant='primary'>{t('job_list.show_details')}</Button>
						</Col>
					</Row>
				</Card.Body>
			</Card>
		</a>
	)
}

export default Job
